import { createReducer, on } from '@ngrx/store';
import { enablePage, loadQueryParameters, enableConfigAPI } from './app-meta.actions';
import { AppMetaInformation } from 'src/app/models/application.interface';
import { UtilsService } from 'src/app/services/utils.service';


export interface AppMetaState {
  metaData: AppMetaInformation;
  status: 'pending' | 'loading' | 'error' | 'success';
  error: string;
}

const initialState: AppMetaState = {
  metaData: {
    disablePage: true,
    stopLoadingSpinner: false,
    noConfigData: false,
    enableConfigAPI: false
  },
  status: 'pending',
  error: '',
};

// Reducers for handling actions
export const appMetaReducer = createReducer(
  initialState,

  on(enablePage, (state, { disablePage, stopLoadingSpinner, noConfigData }) => {
    return {
      ...state,
      metaData: {
        ...state.metaData,
        disablePage: disablePage,
        stopLoadingSpinner: stopLoadingSpinner,
        noConfigData: noConfigData
      },
      status: "success"
    };
  }),

  on(enableConfigAPI, (state, { enableConfigAPI }) => {
    return {
      ...state,
      metaData: {
        ...state.metaData,
        enableConfigAPI: enableConfigAPI
      },
      status: "success"
    };
  }),

  on(loadQueryParameters, (state, { user, id, project, key, lng, country, RID }) => {
    return {
      ...state,
      metaData: {
        ...state.metaData,
        user: user.value,
        id: id.value,
        project: project.value,
        key: key.value,
        lng: lng.value,
        country: country.value,
        RID: RID.value
      }
    };
  })
);
